import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Zap, CircleDot, Dumbbell, Timer, Users, Brain } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Sports Performance Training',
    description: 'Comprehensive athletic development focusing on power, agility, and overall physical capability for any sport.',
    icon: Zap
  }, {
    title: 'Basketball Training',
    description: 'Elite skill development, shooting mechanics, ball handling, and game-situation IQ enhancement.',
    icon: CircleDot // Using CircleDot as a proxy for a basketball
  }, {
    title: 'Strength & Conditioning',
    description: 'Build foundational strength, increase explosive power, and improve functional movement patterns.',
    icon: Dumbbell
  }, {
    title: 'Speed & Agility',
    description: 'Enhance footwork, acceleration, deceleration, and change of direction mechanics.',
    icon: Timer
  }, {
    title: 'Group Training',
    description: 'High-energy, competitive environment pushing athletes to elevate their game alongside peers.',
    icon: Users
  }, {
    title: 'Cognitive Ball Therapy',
    description: 'Specialized training integrating physical movement with cognitive tasks to improve reaction time and focus.',
    icon: Brain
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="services" className="py-20 md:py-28 bg-sep-black text-white" data-id="element-213">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-215">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl uppercase mb-4" data-id="element-216">
            ELITE SERVICES
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-gray-400 text-lg md:text-xl" data-id="element-217">
            Every session is designed to push limits, build confidence, and
            create smarter, stronger athletes.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-218">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-white/5 border border-white/10 p-8 rounded-lg hover:bg-white/10 hover:border-sep-red/50 transition-all duration-300 group" data-id="element-219">
              <div className="w-14 h-14 bg-sep-red/10 text-sep-red rounded-lg flex items-center justify-center mb-6 group-hover:bg-sep-red group-hover:text-white transition-colors duration-300" data-id="element-220">
                <service.icon size={28} strokeWidth={2} data-id="element-221" />
              </div>
              <h3 className="font-heading font-bold text-xl mb-3 group-hover:text-sep-red transition-colors duration-300" data-id="element-222">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-223">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-224">
          <a href="#contact" className="inline-block bg-sep-red hover:bg-sep-red-dark text-white font-bold py-4 px-10 rounded-md transition-colors w-full sm:w-auto" data-id="element-225">
            Book Your Elite Session
          </a>
        </motion.div>
      </div>
    </section>;
}